import ALL_COUNTRIES from './data';
var countriesToSearch = ALL_COUNTRIES;
function isEqual(str1, str2) {
    return str1.toUpperCase() === str2.toUpperCase();
}
function findFlagUrlByPredicate(countries, predicate) {
    var country = countries.find(predicate);
    return country ? country.flag : '';
}
export function findFlagUrlByCountryName(countryName) {
    return findFlagUrlByPredicate(countriesToSearch, function (_a) {
        var _b;
        var name = _a.name, altSpellings = _a.altSpellings;
        return (_b = (isEqual(name, countryName) || (altSpellings === null || altSpellings === void 0 ? void 0 : altSpellings.some(function (altSpelling) { return isEqual(altSpelling, countryName); })))) !== null && _b !== void 0 ? _b : false;
    });
}
export function findFlagUrlByNationality(nationality) {
    return findFlagUrlByPredicate(countriesToSearch, function (_a) {
        var demonym = _a.demonym;
        return isEqual(demonym, nationality);
    });
}
export function findFlagUrlByIso2Code(iso2Code) {
    return findFlagUrlByPredicate(countriesToSearch, function (_a) {
        var iso2 = _a.iso2;
        return isEqual(iso2, iso2Code);
    });
}
export function findFlagUrlByIso3Code(iso3Code) {
    return findFlagUrlByPredicate(countriesToSearch, function (_a) {
        var iso3 = _a.iso3;
        return isEqual(iso3, iso3Code);
    });
}
export function getMapFlagUrlByIso3Code() {
    return ALL_COUNTRIES.reduce(function (acc, _a) {
        var iso3 = _a.iso3, flag = _a.flag;
        acc[iso3] = flag;
        return acc;
    }, {});
}
//# sourceMappingURL=helper.js.map